/**
 * CSV export for admin entities.
 * Usage: exportToCsv(rows, columns, filename)
 */

function escapeCsvCell(v) {
  if (v == null || v === '') return '';
  const s = String(v);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * @param {object[]} rows - Array of row objects
 * @param {{ key: string; label: string }[]} columns - { key, label }
 * @param {string} filename - e.g. 'orders-2026-01-30.csv'
 */
export function exportToCsv(rows, columns, filename) {
  const header = columns.map((c) => escapeCsvCell(c.label)).join(',');
  const body = rows.map((row) =>
    columns.map((c) => escapeCsvCell(row[c.key])).join(',')
  );
  const csv = [header, ...body].join('\r\n');
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename || 'export.csv';
  a.click();
  URL.revokeObjectURL(a.href);
}

export function downloadFilename(prefix) {
  return `${prefix}-${new Date().toISOString().slice(0, 10)}.csv`;
}
